import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CLOSE_CONTEXT_MENU, OPEN_CONTEXT_MENU } from '../actions/ContextMenu';
import { CONTEXT_MENU_HOVER_BUTTON_ID, CONTEXT_MENU_OVERLAY_ID } from './ContextMenuOverlay';
import { executeMethods } from "../actions";
export default function ContextMenuButton(props) {
    const { slot, options, isRefinement, size, variant, iconName, postFixIconName, disabled, text, hover, header, label, showSignInButton, signInButtonText, } = props;
    const [active, setActive] = useState(false);
    const { open } = useSelector((state) => state.ContextMenu);
    const buttonRef = useRef(null);
    const dispatch = useDispatch();
    const openContextMenu = (event) => {
        var _a, _b;
        event.stopPropagation();
        if (event.detail.stopPropagation) {
            event.detail.stopPropagation();
        }
        setActive(true);
        const buttonOffsets = ((_b = (_a = buttonRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) || new DOMRect();
        const buttonHeight = buttonOffsets.height;
        const padding = 14;
        const xOffset = buttonOffsets.left || event.detail.clientX;
        const yOffset = buttonOffsets.top
            ? buttonOffsets.top + buttonHeight + padding
            : event.detail.clientY + padding;
        if (props.onItemSelected) {
            dispatch(executeMethods(props.onItemSelected));
        }
        dispatch({
            type: OPEN_CONTEXT_MENU,
            payload: { options, xOffset, yOffset, refinement: true, hover, header, label, showSignInButton, signInButtonText },
        });
    };
    const closeContextMenu = (event) => {
        var _a, _b, _c, _d;
        if (((_b = (_a = event) === null || _a === void 0 ? void 0 : _a.toElement) === null || _b === void 0 ? void 0 : _b.id) !== CONTEXT_MENU_OVERLAY_ID && ((_d = (_c = event) === null || _c === void 0 ? void 0 : _c.relatedTarget) === null || _d === void 0 ? void 0 : _d.id) !== CONTEXT_MENU_OVERLAY_ID) {
            dispatch({ type: CLOSE_CONTEXT_MENU });
        }
    };
    const handleMouseEvent = (event) => {
        event.stopPropagation();
    };
    const hoverProps = hover
        ? {
            onMouseEnter: openContextMenu,
            onMouseLeave: closeContextMenu,
            id: CONTEXT_MENU_HOVER_BUTTON_ID,
        }
        : {};
    useEffect(() => {
        if (!open) {
            setActive(false);
        }
    }, [open]);
    return (React.createElement("music-button", Object.assign({ tabIndex: 0, slot: slot, onmusicActivate: openContextMenu, "icon-name": iconName, "icon-only": !text, variant: variant, refinement: isRefinement ? (active ? 'open' : 'static') : 'none', size: size, disabled: disabled, onMouseUp: handleMouseEvent, onMouseDown: handleMouseEvent, ref: buttonRef }, hoverProps),
        text || '',
        postFixIconName ? (React.createElement("music-icon", { name: postFixIconName, size: 'tiny', style: { paddingLeft: 5 } })) : null));
}
